








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CzCover extends Vue {
  @Prop({ type: String, default: "" }) image!: string;
  @Prop({ type: String, default: "" }) name!: string;
  @Prop({ type: String, default: "wide" }) size!: "wide" | "thumb" | "small";
}
